import { render } from "./Sv061.vue?vue&type=template&id=45c384f0&scoped=true"
import script from "./Sv061.vue?vue&type=script&lang=js"
export * from "./Sv061.vue?vue&type=script&lang=js"

import "./Sv061.vue?vue&type=style&index=0&id=45c384f0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c384f0"]])

export default __exports__